exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".profile-picture-preview[data-v-864e0d20] {\n  margin-top: 0.8rem;\n  width: 175px;\n  height: 175px;\n  object-fit: cover;\n  border-radius: 50%;\n}\n.required[data-v-864e0d20] {\n  color: red;\n}\n", ""]);

// exports
